module.exports = __webpack_public_path__ + "static/media/phone.3a20cc44.svg";